import PropTypes from 'prop-types'
import React from 'react'

export default function AvatarBorder (props) {
  const { appUser, borderWidth, includeBorder, children, size, borderColor } = props
  if (includeBorder) {
    const margin = { top: borderWidth / 2, right: borderWidth / 2, bottom: borderWidth / 2, left: borderWidth / 2 }
    const fullSize = size + margin.left + margin.right + borderWidth * 2
    const width = fullSize - margin.left - margin.right
    const height = fullSize - margin.top - margin.bottom

    const stroke = appUser ? 'url(#hobnob-gradient)' : '#E5E5E5'
    const borderStroke = borderColor || stroke

    const style = {
      height: `${fullSize}px`,
      width: `${fullSize}px`,
      textAlign: 'initial'
    }

    return (
      <div style={style}>
        <svg style={style}>
          <g transform={`translate(${margin.left}, ${margin.top})`}>
            <circle cx={width / 2} cy={height / 2} r={width / 2} stroke={borderStroke} strokeWidth={borderWidth} fill={stroke} />
            <foreignObject x={borderWidth} y={borderWidth} width={width} height={height}>
              {children}
            </foreignObject>
          </g>
        </svg>
      </div>

    )
  } else {
    return children
  }
}

AvatarBorder.propTypes = {
  appUser: PropTypes.bool,
  borderWidth: PropTypes.number,
  children: PropTypes.any,
  includeBorder: PropTypes.bool,
  size: PropTypes.number,
  borderColor: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/components/common/AvatarBorder.jsx